import { Component, Output, Input, EventEmitter, Injectable } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../../models/messages';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { SecurityService } from '../../../../services/security/security.service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { DatePipe } from '@angular/common';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Injectable()

@Component({
  selector: 'app-nuevo-parametro',
  templateUrl: './nuevo-parametro.component.html',
  styleUrls: ['./nuevo-parametro.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevoParametroComponent {
  @Input() IdParametro: string;
  @Output() cerrarAgregarParametro: EventEmitter<boolean>;
  user: any;
  ipAddress: any;
  maxDate = moment();
  NombreEmpresa: string;
  Titulo: string;
  id_Empresa: string;

  loading: boolean = false;
  isLoading = true;
  save: boolean = false;
  error: boolean = false;
  textError: string = "";

  formularioParametros: FormGroup;

  constructor(private routerActive: ActivatedRoute, private formBuilder: FormBuilder,
    private securityService: SecurityService, private datepipe: DatePipe) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.Titulo = "NUEVO PARAMETRO";
    this.NombreEmpresa = sessionStorage.getItem('empresa');
    this.cerrarAgregarParametro = new EventEmitter();

    this.routerActive.params.subscribe(
      Params => {
        this.id_Empresa = Params['id'];
      });

    this.formularioParametros = formBuilder.group({
      'id_Empresa': [this.id_Empresa, [Validators.required]],
      'Codigo': ['', [Validators.required]],
      'Valor': ['', [Validators.required]],
      'Descripcion': ['', [Validators.required]],
      'Tipo_Parametro': ['', [Validators.required]],
      'Vigente_Desde': [{ disabled: true, value: this.maxDate }, [Validators.required]],
      'Vigente_Hasta': [{ disabled: true, value: '' }],
      'NombreProyecto': [{ disabled: true, value: 'DigitalFactoring' }],
      'Usuario': [{ disabled: true, value: this.user.Usuario }],
      'Host': [{ disabled: true, value: 'INTRANET' }],
      'ip': [{ disabled: true, value: this.ipAddress.ip }],
      'canal': [{ disabled: true, value: 'W' }]
    });

  }

  crearParametro() {
    if (this.formularioParametros.invalid) {
      return false;
    }
    this.loading = true;
    this.error = false;


    this.formularioParametros.controls["Vigente_Desde"].setValue(
      this.datepipe.transform(
        this.formularioParametros.controls["Vigente_Desde"].value,
        "yyyy-MM-dd"
      )
    );
    this.formularioParametros.controls["Vigente_Hasta"].setValue(
      this.datepipe.transform(
        this.formularioParametros.controls["Vigente_Hasta"].value,
        "yyyy-MM-dd"
      )
    );

    this.securityService.GuardarParametros(this.formularioParametros.getRawValue())
      .subscribe(res => {

        this.loading = false;
        this.save = true;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        Swal.fire({
          title: "ADVERTENCIA",
          text: "Parametro no registrado ",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
  }

  CerrarPopUp() {
    this.cerrarAgregarParametro.emit();
  }

}
